export const initShowParams = () => {
  const node = document.getElementById('show-all-params');
  if (node === null) {
    return;
  }

  const showParams = () => {
    const params = document.querySelectorAll('.char-none__mob');

    params.forEach((p) => p.classList.remove('char-none__mob'));
    node.removeEventListener('click', showParams);
    node.remove();
  };

  node.addEventListener('click', showParams);
};
